import { render, staticRenderFns } from "./DeviceArea.vue?vue&type=template&id=52c8de9c&scoped=true"
import script from "./DeviceArea.vue?vue&type=script&lang=js"
export * from "./DeviceArea.vue?vue&type=script&lang=js"
import style0 from "./DeviceArea.vue?vue&type=style&index=0&id=52c8de9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8de9c",
  null
  
)

export default component.exports